// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  //---------------For local Environment--------------------
  //production: false,
  //apiurl: 'https://localhost:44365/api/',
  //baseurl: "http://localhost:44365/",
  //tenantid: "4e54b2fe-9102-403e-9f08-1e8f51752f6b",
  //authority: "https://login.microsoftonline.com/4e54b2fe-9102-403e-9f08-1e8f51752f6b/",
  //clienid: "56cf13d1-1751-41ed-bf64-59880703bd16",
  //redirecturl: "http://localhost:4200",
  //securityapi: 'https://localhost:44365/',
//-------------For Production Environment---------------
  production: true,
  apiurl: 'https://fnoportalai.azurewebsites.net/api/',
  baseurl: "https://fnoportalai.azurewebsites.net/",
  tenantid: "4e54b2fe-9102-403e-9f08-1e8f51752f6b",
  authority: "https://login.microsoftonline.com/4e54b2fe-9102-403e-9f08-1e8f51752f6b/",
  clienid: "56cf13d1-1751-41ed-bf64-59880703bd16",
  redirecturl: "https://esales.rrkabel.com/",
securityapi: 'https://fnoportalai.azurewebsites.net/',
};

